import { User } from "../../../commons/auth";

export class CategoriaPolicy {
  view(user: User, context?: any){
    return true
  }
  register(user: User, context?: any){
    return true
  }
}